module.exports = __webpack_public_path__ + "static/Q4Answer4_Wise_NathanGuzman-545dd47093e1e07360731088ef972f7a.jpg";